"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "15",
    height: "16",
    viewBox: "0 0 15 16"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M30.3818813,141.685354 C30.3818813,138.263479 27.5051136,135.466604 23.9495581,135.466604 C20.3940025,135.466604 17.5333965,138.263479 17.5333965,141.685354 C17.5333965,145.107229 20.4101641,147.904104 23.9657197,147.904104 L23.9657197,145.247854 C21.9455177,145.247854 20.2808712,143.654104 20.2808712,141.685354 C20.2808712,139.716604 21.9293561,138.122854 23.9657197,138.122854 C26.0020833,138.122854 27.6505682,139.716604 27.6505682,141.685354 L27.6505682,144.966604 L24.628346,144.966604 L29.0081439,150.404104 L33.4041035,144.982229 L30.3818813,144.982229 L30.3818813,141.685354 Z",
    transform: "rotate(-90 -51.031 84.435)"
  }));
};

exports["default"] = _default;